module.exports = __webpack_public_path__ + "img/appAsset--compliance--rate--good.4f2b0b41.svg";